/**
 * Utility functions for validating persisted RMC orders
 */

import {OrderIntakeOptionsDto} from '@hconnect/tuc-processes/orderIntake'

import {RmcOrderPayload} from '../services/rmcOrderPlacementService'

/**
 * Checks if there are any persisted orders for a given site
 * This is the initial check when user selects a site
 *
 * @param orders - Array of persisted RMC order payloads
 * @returns true if there are persisted orders, false otherwise
 */
export const hasPersistedOrders = (orders?: RmcOrderPayload[]): boolean => {
  return Boolean(orders && orders.length > 0)
}

/**
 * Validates if persisted orders have materials that are still available in current RMC options
 * This is the detailed validation that should be done when user clicks repeat order button
 *
 * @param orders - Array of persisted RMC order payloads
 * @param options - Current RMC order intake options containing contracts and materials
 * @returns true if at least one persisted order has materials that are still valid, false otherwise
 */
export const validatePersistedOrderMaterials = (
  orders: RmcOrderPayload[],
  options?: OrderIntakeOptionsDto
): boolean => {
  if (!orders || orders.length === 0 || !options) {
    return false
  }

  // Check if materials from persisted orders are still available in current options
  for (const order of orders) {
    if (order.materialNumber) {
      // Look for the material in the contracts
      const materialExists = options.contracts?.some(
        (contract) =>
          contract.materials?.some((material) => material.materialNumber === order.materialNumber)
      )

      if (materialExists) {
        return true // At least one order has valid materials
      }
    }
  }

  return false
}
